import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;
const getToken = () => localStorage.getItem("access_token");

const headers = () => ({
  Authorization: `Bearer ${getToken()}`,
  Accept: "application/json",
  "Content-Type": "application/json",
});
// Get users
export const fetchUsers = async () => {
  const response = await axios.get(`${API_URL}/allusers`, { headers: headers() });
  return response.data.users || response.data.data || [];
};

// Delete user
export const deleteUser = async (userId) => {
  await axios.delete(`${API_URL}/delete-users/${userId}`, { headers: headers() });
};

// Update user status
export const updateUserStatus = async (userId, status) => {
  await axios.post(`${API_URL}/update-userstatus/${userId}`, { status }, { headers: headers() });
};

//For Categories
export const fetchCategories = async () => {
  const response = await axios.get(`${API_URL}/get-allcategories`, { headers: headers() });
  return response.data.categories || response.data.data || [];
};
export const deleteCategories = async (id) => {
  const response = await axios.delete(`${API_URL}/delete-category/${id}`, {
    headers: headers(),
  });
  return response.data;
};


export const updateCategories = async (id, formData, token) => {
  const response = await axios.post(
    `${API_URL}/update-category/${id}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",

      },
    }
  );

  return response.data;
};

//For Banners

export const fetchBanner = async () => {
  const response = await axios.get(`${API_URL}/get-banner`, {
    headers: headers()
  });
  return response.data.categories || response.data.data || [];

};

export const deleteBanner = async (bannerId) => {
  const response = await axios.delete(`${API_URL}/delete-banner/${bannerId}`, {
    headers: headers(),
  });
  return response.data;

}
export const updateBanner = async (id, formData, token) => {
  const response = await axios.post(
    `${API_URL}/update-banner/${id}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",

      },
    }
  );

  return response.data;
}

//For Subscription---
export const fetchSubscription = async () => {
  const response = await axios.get(`${API_URL}/getall-subscription`, {
    headers: headers(),
  });
  return response.data;

}
export const deleteSubscription = async (subscriptionId) => {
  const response = await axios.delete(`${API_URL}/delete-subscription/${subscriptionId}`, {
    headers: headers(),
  });
  return response.data;
}

export const updateSubscription = async (id, formData, token) => {
  const response = await axios.post(`${API_URL}/update-subscription/${id}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",

      },
    }
  );

  return response.data;
};

export const fetchDevices = async () => {
  const response = await axios.get(`${API_URL}/get-devices`, {
    headers: headers(),
  });
  return response.data;

}
export const deleteDevices = async (id) => {
  const response = await axios.delete(`${API_URL}/delete-devices/${id}`,
    {
      headers: headers(),
    });
  return response.data;
}

export const updateDevices = async (userId, status) => {
  await axios.post(`${API_URL}/update-devicestatus/${userId}`, { status }, { headers: headers() });
};

//get devices which assign user
export const fetchuserDevices = async () => {
  const response = await axios.get(`${API_URL}/user-with-device`, { headers: headers() });
  return response.data.users || response.data.data || [];
};


export const deleteuserDevices = async (id) => {
  const response = await axios.delete(`${API_URL}/delete-userdevice?id=${id}`,
    {
      headers: headers(),
    });
  return response.data;
}
const Api = {
  fetchUsers,
  deleteUser,
  updateUserStatus,
  fetchCategories,
  deleteCategories,
  updateCategories,
  fetchBanner,
  deleteBanner,
  updateBanner,
  fetchSubscription,
  deleteSubscription,
  updateSubscription,
  fetchDevices,
  updateDevices,
  deleteDevices,
  fetchuserDevices,
  deleteuserDevices,

};


export default Api;
